import { render, staticRenderFns } from "./creditors_report.vue?vue&type=template&id=545f2714&"
import script from "./creditors_report.vue?vue&type=script&lang=js&"
export * from "./creditors_report.vue?vue&type=script&lang=js&"
import style0 from "./creditors_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports